import {IComponentOptions, ILogService, IRootScopeService} from "angular";
import {ChatService} from "../../chat/chat.service";
import {User} from "../../model/User";

class ApplicationCommentsButtonController {

    private firebaseDatabasePath: string;
    private shown: boolean;
    private onShow: any;
    private unreadApplicationMessages: boolean;
    private currentUser: User;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $rootScope: IRootScopeService,
                private $scope: any,
                private firebase: any,
                private chatService: ChatService) {
    }

    public $onInit() {
        // listen to unread status changes
        const groupPath = this.chatService.generateChannelName("group");
        const groupReadByPath = this.chatService.generateChannelReadByName("group");
        const applicationMessageChatGroupPath = `${this.firebaseDatabasePath}/${groupPath}`;
        const applicationMessageChatGroupReadByPath = `${this.firebaseDatabasePath}/${groupReadByPath}`;

        const applicationMessageChatGroupReadByRef = this.firebase.database().ref(applicationMessageChatGroupReadByPath);
        applicationMessageChatGroupReadByRef.on("value", (readyBySnapshot) => {
            if (this.shown) {
                this.$log.debug("Comments already shown - set unreadApplicationMessages to false");
                this.unreadApplicationMessages = false;
                return;
            }

            const readByNode = readyBySnapshot.val();
            const currentUserReadAllMessages = readByNode && readByNode.hasOwnProperty(this.currentUser.username);

            this.$log.debug("currentUserReadAllMessages", currentUserReadAllMessages);

            if (!currentUserReadAllMessages) {
                // No readBy status for current user. Check if there are any messages
                this.firebase.database().ref(applicationMessageChatGroupPath).once("value").then((messagesSnapshot) => {
                    this.$log.debug("New messages...", messagesSnapshot.val());
                    this.unreadApplicationMessages = !!messagesSnapshot.val();
                });
            } else {
                this.unreadApplicationMessages = false;
            }
        });
    }

    public showComments() {
        this.$log.debug("showComments");

        this.$rootScope.$broadcast("chat:markAsRead", {
            firebaseDatabasePath: this.firebaseDatabasePath,
            chat: "group"
        });

        this.onShow({
            $event: {}
        });
    }

}

export const ApplicationCommentsButtonComponent: IComponentOptions = {
    bindings: {
        firebaseDatabasePath: "<",
        shown: "<",
        onShow: "&",
        currentUser: "<"
    },
    controller: ApplicationCommentsButtonController,
    template: require("./application-comments-button.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/comments-button/application-comments-button.component.ts